var SpriteSymbol = require("../../../../../nike-mobile/node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../../../nike-mobile/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");
var symbol = new SpriteSymbol({
  "id": "live-stream-sl",
  "use": "live-stream-sl-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"live-stream-sl\"><path d=\"M7 0a7 7 0 110 14A7 7 0 017 0zm0 1.5a5.5 5.5 0 100 11 5.5 5.5 0 100-11zM4.568 4.119a.5.5 0 01.684-.18l4.508 2.63a.5.5 0 010 .863l-4.508 2.63a.5.5 0 01-.752-.433V4.371c0-.089.024-.176.068-.252z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id